import React, { lazy, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { themeChange } from "theme-change";
import checkAuth from "./app/auth";
import initializeApp from "./app/init";
import { createTheme, ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import appTheme from "./AppTheme";
import { GlobalStyles } from '@mui/material';

// Importing pages
const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const VerifyAccount = lazy(() => import("./pages/VerifyAccount"));
const SodaStreamTracking = lazy(() => import("./pages/SodaStreamTrackingPage"));
const MiroTracking = lazy(() => import("./pages/MiroTrackingPage"));
const ParcelScan = lazy(() => import("./pages/ParcelScanPage"))

// Initializing different libraries
initializeApp();

// Check for login and initialize axios
const token = checkAuth();

function App() {
  useEffect(() => {
    themeChange(false);
  }, []);

  return (
    <ThemeProvider theme={appTheme}>
      <GlobalStyles
        styles={{
          ".round-shaded-icon-40": {
            width: "40px !important",
            height: "40px !important",
            color: appTheme.palette.primary.main,
            backgroundColor: appTheme.palette.secondary.main,
            borderRadius: "20px",
            padding: 5,
          },
          ".mrt-header": {
            backgroundColor: "#19364D !important",
          },
          ".mrt-header .MuiTableCell-head": {
            color: "#FFFFFF !important",
            fontWeight: 600,
          },
          ".MuiTableSortLabel-root": {
            color: "#FFFFFF !important",
          },

          // Active (sorted) state color
          ".MuiTableSortLabel-root.Mui-active": {
            color: "#FFFFFF !important",
          },

          ".MuiTableSortLabel-icon": {
            color: "#FFFFFF !important",
          },

          ".MuiTableSortLabel-root:hover": {
            color: "#74E8C7 !important",
          },
          ".mrt-column-filter-tr, .mrt-th, .MuiTableCell-root": {
            overflow: "visible !important",
            position: "relative !important",
            zIndex: 10,
          },
        }}
      />
      <ToastContainer
        position="top-center"
        toastClassName="custom-toast"
        progressClassName="custom-toast-progress"
      />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify-account" element={<VerifyAccount />} />
          <Route path="/sodastream-tracking" element={<SodaStreamTracking />} />
          <Route path="/miro-tracking" element={<MiroTracking />} />
          <Route path="/parcel-scan" element={<ParcelScan />} />

          {/* Place new routes over this */}
          <Route path="/app/*" element={<Layout />} />

          <Route
            path="*"
            element={
              <Navigate to={token ? "/app/welcome" : "/login"} replace />
            }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
